import { render, staticRenderFns } from "./BlockThemesItem.vue?vue&type=template&id=245ceaf0&"
import script from "./BlockThemesItem.vue?vue&type=script&lang=js&"
export * from "./BlockThemesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports